export default {
  _not_interested_in_this_video: '当前视频不感兴趣吗？ %second%',
  _switch_one: '换一个',
}